import React from 'react';
import { X } from 'lucide-react';

/**
 * FilterChip Component
 * Displays an active filter as a removable chip/pill
 *
 * @param {string} label - Filter label (e.g., "Status: Active Client")
 * @param {function} onRemove - Callback when X is clicked
 */
const FilterChip = ({ label, onRemove }) => {
  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 'var(--space-2)',
        padding: '6px 12px',
        backgroundColor: 'var(--cta-blue-muted)',
        color: 'var(--cta-blue)',
        borderRadius: 'var(--radius-full)',
        fontSize: 'var(--text-sm)',
        fontWeight: 'var(--font-medium)',
        border: '1px solid var(--cta-blue)',
        transition: 'all 0.2s',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = 'var(--cta-blue)';
        e.currentTarget.style.color = 'white';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = 'var(--cta-blue-muted)';
        e.currentTarget.style.color = 'var(--cta-blue)';
      }}
    >
      <span>{label}</span>
      <button
        onClick={onRemove}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'none',
          border: 'none',
          padding: 0,
          cursor: 'pointer',
          color: 'inherit',
          width: '16px',
          height: '16px',
          borderRadius: 'var(--radius-full)',
          transition: 'background-color 0.2s',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.2)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = 'transparent';
        }}
        aria-label={`Remove ${label} filter`}
      >
        <X size={14} />
      </button>
    </div>
  );
};

export default FilterChip;
